import React from 'react';
import { SpecialItem } from './SpecialItem';
import { RegularItem } from './RegularItem';
import { shopApi } from 'api';

interface ItemProps {
  item: shopApi.Item;
  special?: boolean;
  size?: 'm' | 's';
  onPaymentClick?: (event: React.MouseEvent) => void;
  onItemClick?: (item: shopApi.Item) => void;
}

export const Item: React.FC<ItemProps> = ({ ...props }) => {
  const isSpecial = props.special;

  if (isSpecial) {
    return <SpecialItem {...props} />;
  }

  return <RegularItem {...props} />;
};
